import '@shinetools/lumen-tokens/web'

import { loadModules } from './utils/loadModules'

export * from './utils/setLanguage'

/* Enforce Lumen to use light mode and adhere to whatever inversion Billy is doing to achieve dark mode */
document.documentElement.setAttribute('data-theme', 'light')

loadModules()
